import { ICollectionsType } from "../components/interfaces/HomepageInterface";

export const APPLE_WATCH_SERIES_10_TEXT = "Apple Watch Series 10";
export const APPLE_WATCH_HERMES_SERIES_10_TEXT = "Apple Watch Hermès Series 10";
export const APPLE_WATCH_SE_TEXT = "Apple Watch SE";
export const collectionsTypeList: ICollectionsType[] = [
  {
    id: 1,
    typeName: APPLE_WATCH_SERIES_10_TEXT,
  },
  {
    id: 2,
    typeName: APPLE_WATCH_HERMES_SERIES_10_TEXT,
  },
  {
    id: 3,
    typeName: APPLE_WATCH_SE_TEXT,
  },
];
export const SIZE_TEXT = "Size";
export const CASE_TEXT = "Case";
export const BAND_TEXT = "Band";
export const ALUMINIUM_TEXT = "Aluminium";
export const TITANIUM_TEXT = "Titanium";
export const APPLE_WATCH_CASES_LIST = [ALUMINIUM_TEXT, TITANIUM_TEXT];
export const APPLE_WATCH_SIZES_LIST = ["42mm", "46mm"];

export const STAINLESS_STEEL_TEXT = "Stainless Steel";
export const SPORT_LOOP_TEXT = "Sport Loop";
export const SPORT_BAND_TEXT = "Sport Band";
export const FINEWOVEN_TEXT = "FineWoven";
export const BRAIDED_SOLO_LOOP_TEXT = "Braided Solo Loop";
export const SOLO_LOOP_TEXT = "Solo Loop";
export const NIKE_SPORT_LOOP_TEXT = "Nike Sport Loop";
export const NIKE_SPORT_BAND_TEXT = "Nike Sport Band";

export const APPLE_WATCH_BANDS_LIST = [
  STAINLESS_STEEL_TEXT,
  SPORT_LOOP_TEXT,
  SPORT_BAND_TEXT,
  FINEWOVEN_TEXT,
  BRAIDED_SOLO_LOOP_TEXT,
  SOLO_LOOP_TEXT,
  NIKE_SPORT_LOOP_TEXT,
  NIKE_SPORT_BAND_TEXT,
];
